<template>
  <modal
    :name="name"
    :height="height"
    :width="width"
    class="modal"
    :adaptive="true"
    @closed="$emit('closed')"
  >
    <div class="custom-modal">
      <div
        :class="[
          title ? 'space-between' : 'justify-end',
          'modal-header flex align-center'
        ]"
      >
        <div v-if="title" class="modal-heading">
          <h2>{{ title }}</h2>
          <p v-if="para">{{ para }}</p>
        </div>
        <div class="close">
          <button class="close-button" @click="$modal.hide(name)">×</button>
        </div>
      </div>
      <div class="modal-content">
        <slot name="content"></slot>
      </div>
      <div v-if="$slots.footer || $scopedSlots.footer" class="modal-footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    para: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      required: true
    },
    height: {
      type: String
    },
    width: {
      type: String
    }
  }
};
</script>

<style scoped>
.modal {
  z-index: 5000;
}

.modal > .vm--modal {
  overflow: visible !important;
}

.custom-modal {
  padding: 1.8rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  overflow: visible;
}

.custom-modal .modal-header {
  border-bottom: 1px solid var(--line);
  flex-shrink: 0;
}

.modal-content {
  flex-grow: 1;
  overflow: visible;
  padding-top: 1rem;
}

.modal-footer {
  margin-top: 1rem;
  flex-shrink: 0;
  border-top: 1px solid var(--line);
  padding-top: 1rem;
}

.custom-modal .modal-header .modal-heading h2 {
  margin: 0;
  padding: 0;
  font-weight: 600;
  font-size: var(--fs-eyebrow);
  line-height: 38px;
  letter-spacing: var(--tracking-eyebrow);
  color: var(--muted);
  text-transform: uppercase;
}

.custom-modal .modal-header .modal-heading p {
  margin: 0 0 12px;
  max-width: 320px;
  font-size: var(--fs-sm, 0.875rem);
  font-weight: 400;
  line-height: 1.45;
  letter-spacing: 0;
  text-transform: none;
  color: var(--muted-soft, var(--muted));
}

.custom-modal .close button {
  background: transparent;
  border: none;
  font-size: 2rem;
  color: var(--muted-soft);
  transition: color var(--dur) var(--ease);
}

.custom-modal .close button:hover {
  color: var(--text);
}

@media (max-height: 640px) {
  .modal-content {
    overflow-y: auto;
    max-height: calc(80vh - 6rem);
  }
}
</style>
